import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Persistor, store } from "./reduxStore";

import "./index.css";
import "aws-amplify/auth/enable-oauth-listener";
import { configureAmplifyAuth, AUTH_CALLBACK_PATH } from "./config/amplifyAuth";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import {
  initAmplitudeAnalytics,
  initGlobalExceptionTracking,
} from "./utils/amplitudeAnalytics";

configureAmplifyAuth();
initAmplitudeAnalytics();
initGlobalExceptionTracking();

if (typeof window !== "undefined" && window.location?.search) {
  const params = new URLSearchParams(window.location.search);
  const hasCode = params.has("code");
  const hasState = params.has("state");
  const isCallbackPath = window.location.pathname === AUTH_CALLBACK_PATH;
  if (hasCode && hasState && !isCallbackPath) {
    window.location.replace(
      `${window.location.origin}${AUTH_CALLBACK_PATH}${window.location.search}`,
    );
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={Persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
